class ClassNewsletter {

    constructor() {
        this.getObjects = this.getObjects();
    }

    getObjects = () => {
        return {
            name: '',
            email: '',
            acceptPolicy: false
        }
    }
}

export default ClassNewsletter;